/**
 * Runtime configuration for ZcashWallet's shielded backend integration.
 *
 * Single source of truth for the URLs we talk to. Don't sprinkle these
 * across the codebase — components import from here so a future move
 * (different shielded host, region failover, etc.) is one edit.
 */

const ENV = (import.meta as ImportMeta & { env: Record<string, string | undefined> }).env;

/** Shielded backend root: SEV-SNP attested, HPKE-sealed UFVK scanner. */
export const SHIELDED_BASE_URL =
  ENV?.VITE_LEOKIT_SHIELDED_URL ?? "https://shielded.leokit.dev";

/**
 * Versioned WASM artefact base. Bumped via the import map / explicit init
 * URL in the SDK signer. Held here as a single constant so a future
 * v0.0.3 bump is one edit, not a grep.
 */
export const SHIELDED_WASM_BASE_URL = `${SHIELDED_BASE_URL}/wasm`;

/**
 * Sapling proving params CDN. Serves the bls12-381 point-compressed
 * shards produced by `tools/sapling-params-recompress`. The Service
 * Worker / Cache Storage layer prefetches both files during the
 * post-mnemonic onboarding flow.
 *
 * Dev default points at the local teleswap-bot's static surface
 * (http://localhost:8080/params/v1). Prod should override to the
 * deployed CDN URL via VITE_SAPLING_PARAMS_URL.
 */
export const SAPLING_PARAMS_BASE_URL =
  ENV?.VITE_SAPLING_PARAMS_URL ?? `${SHIELDED_BASE_URL}/params/v1`;
